import SortableTableHead from 'Components/TableBase/SortableTableHead';
import { StyledTable } from 'Components/TableBase/Table';
import React, { FC } from 'react';
import {
  IQuestionnaire,
  IQuestionnaireCompanyResponse,
} from 'FeatureModules/Questionnaire/types/questionnaire.types';
import QuestionnaireResponseTableBody from './QuestionnaireResponseTableBody';
import {
  EQuestionnaireResponseHeaderColumnEnum,
  getQuestionnaireResponseHeaderColumns,
} from './questionnaireResponseHeaderColumns';

interface IQuestionnaireResponseTableProps {
  questionnaire: IQuestionnaire;
  responses: IQuestionnaireCompanyResponse[];
  hideHeader?: boolean;
  columns: EQuestionnaireResponseHeaderColumnEnum[];
  onResponseClick: (response: IQuestionnaireCompanyResponse) => void;
}

const QuestionnaireResponseTable: FC<IQuestionnaireResponseTableProps> = ({
  responses,
  questionnaire,
  hideHeader = false,
  columns,
  onResponseClick,
}) => {
  const headerColumns = getQuestionnaireResponseHeaderColumns(columns);

  return (
    <StyledTable data-testid="questionnaire-responses-table">
      {!hideHeader && <SortableTableHead headerColumns={headerColumns} />}

      <QuestionnaireResponseTableBody
        questionnaire={questionnaire}
        responses={responses}
        onResponseClick={onResponseClick}
        headerColumns={headerColumns}
      />
    </StyledTable>
  );
};

export default QuestionnaireResponseTable;
